import { _Api } from "../../api/_call";
import { error, success } from "./toastify";

/**
 * Download PO / PU import sample (same fields as poProductExport / puProductExport).
 * @param {"PO"|"PU"} type
 * @param {"xlsx"|"csv"} format
 * @param {(key: string) => string} [t]
 */
export const downloadPoPuSampleTemplate = async (
  type = "PO",
  format = "xlsx",
  t = (s) => s
) => {
  const isPu = String(type).toUpperCase() === "PU";
  const exportFormat = String(format).toLowerCase() === "csv" ? "csv" : "xlsx";
  const url = isPu
    ? "api/v1/Inventory/purchase/puSampleTemplate"
    : "api/v1/Inventory/po/poSampleTemplate";
  const fileName = isPu
    ? `PU_Import_Sample.${exportFormat}`
    : `PO_Import_Sample.${exportFormat}`;

  try {
    const res = await _Api({ format: exportFormat }, url);
    if (res?.code === 200 && res?.filexlsx) {
      const a = document.createElement("a");
      a.hidden = true;
      a.href = res.filexlsx;
      a.download = fileName;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      a.remove();
      success(res?.message || t("Sample template downloaded"));
      return true;
    }
    error(res?.message || res?.error || t("Could not download sample template"));
    return false;
  } catch (err) {
    console.log(err, "downloadPoPuSampleTemplate");
    error(t("Could not download sample template"));
    return false;
  }
};

/** Open Bootstrap modal used for sample format picker */
export const openPoPuSampleFormatModal = (modalId = "poPuSampleFormatModal") => {
  const el = document.getElementById(modalId);
  if (el && window.bootstrap?.Modal) {
    window.bootstrap.Modal.getOrCreateInstance(el).show();
  } else if (el) {
    // fallback if bootstrap global missing — still try data API
    el.classList.add("show");
    el.style.display = "block";
  }
};
